import { Observable, of } from 'rxjs';
import { AuthStore } from '../state/auth.store';

export function restoreAuthSession(authStore: InstanceType<typeof AuthStore>): Observable<boolean> {
  authStore.initializeFromStorage();

  if (authStore.isAuthenticated()) {
    return of(true);
  }

  // A refresh cookie is only meaningful when this installation has previously
  // persisted a user. Fresh/native installs must reach the login route without
  // waiting on an anonymous refresh request (or surfacing its expected 401).
  return authStore.rehydrateFromCookie();
}
